/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import LogOutAction from './LogOutAction/index'
import React from 'react'
import TitleLarge from 'DesignSystem/TitleLarge/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Empty({
  children,
  viewPath = "/App/Account/Empty"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="Empty.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Empty.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-1-4PwO0': dtColorsWhite}}
 className={`views-block ${styles.Vertical1}`}
>
<TitleLarge
  viewPath={`${viewPath}/TitleLarge`}
 color="#e15829"
 text="Patient Hub access is disabled."
 textAlign="center"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontWeight={300}
 hyphens="none"
 marginTop={30}
 text="We apologize for the inconvenience."
 textAlign="center"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontWeight={300}
 hyphens="none"
 marginTop={10}
 text="If you think this is wrong, please report the problem to your clinic."
 textAlign="center"
/>
<div
  data-testid="Empty.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<LogOutAction
  viewPath={`${viewPath}/LogOutAction`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}